import React, { useState } from 'react';
import unique from 'unique-selector';
import { useSelector } from 'react-redux';
import { selectIsNotMode, selectNotes, selectActiveEntityId } from '../../redux/notesetting/notesSettingsSlice';
import { getCoords, getNotableElement } from '../../utility/helpers';
import ExternalCreateNoteForm from './ExternalCreateNoteForm';
import ExternalNote from './ExternalNote';

const ExternalPage = ({ children, setCommentsData, workflowContactId,imageData}) => {
  const [pendingNote, setPendingNote] = useState(null);
  const isNoteMode = useSelector(selectIsNotMode);
  const notes = useSelector(selectNotes);
  const activeNoteId = useSelector(selectActiveEntityId);
  const [isOpen, setIsOpen] = useState(true);
  console.log('notempde', isNoteMode);

  const handleConditionalClick = (e) => {
    const target = e.target;

    // Only proceed if the target is an <img> or inside an <img>
    if (target.tagName.toLowerCase() !== 'img' && !target.closest('img')) {
      return;
    }

    console.log(e, 'e e e 2');
    console.log('target', target, target.closest('.zoom-button'));

    if (target.closest('.zoom-button')) return;
    if (target.closest('.comment-section')) return;

    const targetClass = target.className;

    if (!activeNoteId && targetClass === '') {
      handlePageClick(e);
    }

    if (isOpen && targetClass === '') {
      handlePageClick(e);
    }
  };

  const handlePageClick = (e) => {
    console.log(e, 'eeeeeeee');
    e.preventDefault();
    setIsOpen(true);
    const element = getNotableElement(e.target);
    const elementUniqueSelector = unique(element);
    console.log(
      {
        targetSelector: elementUniqueSelector,
        coords: getCoords(e, element),
      },
      'testttt',
    );

    setPendingNote({
      targetSelector: elementUniqueSelector,
      coords: getCoords(e, element),
    });
  };

  return (
    <>
      <div
        className={isNoteMode ? 'page-wrapper note-mode' : 'page-wrapper'}
        onClick={isNoteMode ? handleConditionalClick : undefined}
      >
        {children}
      </div>
      {console.log({ isNoteMode, notes, pendingNote })}
      {isNoteMode && (
        <>
          {pendingNote && (
            <ExternalCreateNoteForm pendingNote={pendingNote} setPendingNote={setPendingNote} isOpen={isOpen} imageData={imageData} workflowContactId={workflowContactId} />
          )}
          {Array.isArray(notes) &&
            setCommentsData &&
            notes.map((note) => {
              return (
                <ExternalNote

                  workflowContactId={workflowContactId}
                  key={note.id}
                  note={note}
                  setCommentsData={setCommentsData}
                  isOpen={isOpen}

                />
              );
            })}
        </>
      )}
    </>
  );
};

export default ExternalPage;
